import * as React from 'react'

const DescriptionColumns = ({ items }) => (
	<section className="bg-suede-black text-white">
		<dl className="max-w-screen-xl mx-auto py-16 px-4 grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-x-12 gap-y-6">
			{items?.map(({ title, text }, key) => (
				<div className="pl-4 border-l border-suede-dark" key={key}>
					<dt className="font-bold">{title}</dt>
					<dd className="mt-2">{text}</dd>
				</div>
			))}
		</dl>
	</section>
)

export default DescriptionColumns
